import {z} from 'zod'

export const AuthUserPermissionsFeature = z.enum([
    'accesses',
    'agenda',
    'patients',
    'medicalRecords',
    'requests',
    'projects',
    'conversations',
    'settings',
    'users'
])
export type AuthUserPermissionsFeature = z.infer<typeof AuthUserPermissionsFeature>

export const AuthUserPermissions = z
    .object({
        accesses: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        agenda: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        patients: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        medicalRecords: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        requests: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        projects: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        conversations: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        settings: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        users: z.object({
            read: z.boolean(),
            write: z.boolean()
        }),
        userDetails: z.object({
            read: z.boolean(),
            write: z.boolean()
        })
    })
    .default({
        accesses: {
            read: true,
            write: true
        },
        agenda: {
            read: true,
            write: true
        },
        patients: {
            read: true,
            write: true
        },
        medicalRecords: {
            read: true,
            write: true
        },
        requests: {
            read: true,
            write: true
        },
        projects: {
            read: true,
            write: true
        },
        conversations: {
            read: true,
            write: true
        },
        settings: {
            read: true,
            write: true
        },
        users: {
            read: true,
            write: true
        },
        userDetails: {
            read: true,
            write: true
        }
    })
export type AuthUserPermissions = z.infer<typeof AuthUserPermissions>

export const AuthUser = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    fullName: z.string(),
    email: z.string(),
    avatarUrl: z.string().url().nullable(),
    roleId: z.string().nullable(),
    newEmailToVerify: z.string().nullable(),
    permissions: AuthUserPermissions
})
export type AuthUser = z.infer<typeof AuthUser>

const AuthState = z.object({
    user: AuthUser.nullable(),
    accessToken: z.string(),
    refreshToken: z.string()
})
export type AuthState = z.infer<typeof AuthState>
